import { ModuleWithProviders, NgModule } from "@angular/core";
import { WfLocalePipe, WF_LANG_RESOURCES } from "./pipe/wf-process-editor-locale.pipe";

@NgModule({
  declarations: [
    WfLocalePipe
  ],
  exports: [
    WfLocalePipe
  ]
})
export class WfLocaleModule {
  static forRoot(resources?: any): ModuleWithProviders {
    return {
      ngModule: WfLocaleModule,
      providers: [
        { provide: WF_LANG_RESOURCES, useValue: resources || {} },
      ],
    };
  }
}
